module.exports = __webpack_public_path__ + "img/ab-tests-empty-list-light.8a5bdfd3.svg";